// extracted by mini-css-extract-plugin
module.exports = {"video":"video_video__2t_mk","video_ctrl":"video_video_ctrl__1SGQl","right":"video_right__UibnU","video_":"video_video___3nO7Q"};